import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ScenarioComparisonComponent } from './scenario-comparison.component';


const routes: Routes = [
  {
    path: '',
    component: ScenarioComparisonComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ScenarioComparisonRoutingModule { }
